import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { computeScaleAdaptedToFrame } from 'helpers/media'
import "./video.css"
import classNames from 'classnames'

export class Video extends Component {

    state = {
        location: this.props.location,
        videoStyle: null,
    }

    static propTypes = {
        location: PropTypes.object.isRequired,
        format: PropTypes.string.isRequired,
        frame: PropTypes.object.isRequired,
        sourceLoading: PropTypes.func.isRequired,
        sourceLoaded: PropTypes.func.isRequired,
        unableToLoadMedia: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
    }

    updateVideoWrapperSize = () => {
        const { frame } = this.props
        const { videoWidth, videoHeight } = this.video

        this.props.sourceLoaded()

        const scale = computeScaleAdaptedToFrame(frame, { width: videoWidth, height: videoHeight })

        this.setState({
            videoStyle: {
                style: {
                    width: videoWidth * scale,
                    height: videoHeight * scale,
                }
            }
        })
    }
    
    loadVideo()
    {
        this.props.sourceLoading()

        this.video.pause()
        this.video.load()
        this.video.addEventListener("loadeddata", this.updateVideoWrapperSize)
        this.video.addEventListener("error", this.props.unableToLoadMedia)
    }
    
    componentDidMount() {
        this.loadVideo()
    }

    componentWillUnmount() {
        this.video.removeEventListener("loadeddata", this.updateVideoWrapperSize)
        this.video.removeEventListener("error", this.props.unableToLoadMedia)
        this.video = null
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.location.original !== nextProps.location.original) {
            this.loadVideo()
        }
    }

    render() {
        const { location, format } = this.props
                    
        return (
            <div className="video-stage">
                <div className="video-wrapper">
                    <video {...this.state.videoStyle}
                        controls="controls"
                        ref={(video) => {this.video = video}}
                        src={location.original}
                        type={format}
                        className={classNames({ "hidden": ! this.props.isSourceLoaded })}
                    />
                </div>
            </div>
        )
    }
}
